import { staticContacts } from "../Constants/Mock";
import { normalizeContactsData } from "./Normalizers";
import useCallAxios from "./useCallAxios";

const filterQuery = (values) => ({ ...values });

export const useContactsData = () => {
  const context = `contactStatement`;
  const { reset, requestSuccess, requestData, requestLoading, fetchGET } =
    useCallAxios({
      context,
    });

  const handleGET = (params) => {
    fetchGET({ context, queryParameters: filterQuery(params) });
  };

  //const state = normalizeContactsData(requestData);
  const state = normalizeContactsData({
    data: { itens: staticContacts },
  });
  return {
    reset,
    loading: requestLoading,
    state,
    success: requestSuccess,
    handleGET,
  };
};
